define('uikit/elements/progress',['require','exports','module','underscore','marionette','templates','../mixins/component.mixin'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var Templates = require('templates');
  var ComponentMixin = require('../mixins/component.mixin');

  var Progress = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui progress',

    template: Templates.App['progress'],

    options: {
      percent: 0,
      transition: '300ms',
      active: false,
      text: '',
      state: '',
      showPercent: false,
      inverted: false,
      attached: false,
      size: null,
      color: null,
      disabled: false
    },

    forceUpdate: { transition: true, attached: true, text: true },

    ui: {
      bar: '.bar',
      progress: '.progress',
      text: '.label'
    },

    updateAttributes: function() {
      this
          .addClass('active', this.getBoolOption('active'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass('inverted', this.getBoolOption('inverted'))
          .addClass(this.size, this.getBoolOption('size'))
          .addClass(this.color, this.getBoolOption('color'))

      if (this.attached) {
        if (_.isString(this.attached)) {
          this.addClass(this.attached + ' attached', true);
        } else {
          this.addClass('bottom attached', true);
        }
      }

      switch (this.state) {
        case 'success':
          this.addClass('success', true);
          break;
        case 'warning':
          this.addClass('warning', true);
          break;
        case 'error':
          this.addClass('error', true);
          break;
      }

      this.ui.bar.css('width', this.percent + '%');
      if (this.showPercent) {
        this.ui.progress.text(this.percent + '%');
      } else {
        this.ui.progress.text('');
      }

      if (this.ui.text) {
        this.ui.text.text(this.getOption('text'));
      }
    }
  });

  module.exports = Progress;
});
